interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  alwaysShowWordmark?: boolean;
  className?: string;
}

const imgClass = {
  sm: 'h-10 w-10',
  md: 'h-12 w-12',
  lg: 'h-16 w-16',
};

const titleClass = {
  sm: 'text-lg',
  md: 'text-xl',
  lg: 'text-3xl',
};

const scriptClass = {
  sm: 'text-[9px]',
  md: 'text-[10px]',
  lg: 'text-xs',
};

export default function BrandLogo({
  size = 'md',
  showWordmark = true,
  alwaysShowWordmark = false,
  className = '',
}: BrandLogoProps) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/logo.png"
        alt={showWordmark ? '' : 'Reals Store'}
        className={`${imgClass[size]} object-contain flex-shrink-0 drop-shadow-[0_0_10px_rgba(225,6,0,0.4)]`}
      />
      {showWordmark && (
        <span
          className={`${alwaysShowWordmark ? 'flex' : 'hidden sm:flex'} flex-col leading-none select-none`}
        >
          <span className={`font-display tracking-[0.2em] text-white ${titleClass[size]}`}>
            REALS
          </span>
          <span className={`font-display tracking-[0.42em] text-rs-accent ${scriptClass[size]}`}>
            STORE
          </span>
        </span>
      )}
    </span>
  );
}
